import React from 'react';

export type BarChartItem = {
  label: string;
  value: number;
  title?: string;
};

type BarChartProps = {
  ariaLabel: string;
  className?: string;
  items: BarChartItem[];
  maxBarHeight?: number;
};

export function BarChart({ ariaLabel, className = 'fleet-bars', items, maxBarHeight = 204 }: BarChartProps) {
  const maxValue = Math.max(...items.map((item) => item.value), 1);

  return (
    <div className={className} aria-label={ariaLabel}>
      {items.map((item, index) => (
        <div className="fleet-bar-col" key={`${item.label}-${index}`} title={item.title}>
          <strong>{item.value.toLocaleString()}</strong>
          <span className="fleet-bar" style={{ height: `${(item.value / maxValue) * maxBarHeight}px` }} />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
